document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".js-drawer-trigger");
  const drawers = document.querySelectorAll(".flyout-drawer");

  // Open drawer
  function openDrawer(index) {
    closeAllDrawers();
    const drawer = document.querySelector(`.flyout-drawer[data-index="${index}"]`);
    if (drawer) {
      drawer.classList.add("open");
      drawer.setAttribute("aria-hidden", "false");
    }
  }

  // Close all drawers
  function closeAllDrawers() {
    drawers.forEach(d => {
      d.classList.remove("open");
      d.setAttribute("aria-hidden", "true");
      // also close submenus
      d.querySelectorAll(".flyout-submenu").forEach(sub => {
        sub.classList.remove("open");
        sub.setAttribute("aria-hidden", "true");
      });
    });
  }

  // Drawer triggers (hover for desktop, click for mobile)
  triggers.forEach(trigger => {
    const index = trigger.dataset.index;

    // Desktop hover
    trigger.addEventListener("mouseenter", () => {
      if (window.innerWidth > 1024) {
        openDrawer(index);
      }
    });

    // Mobile click
    trigger.addEventListener("click", e => {
      if (window.innerWidth <= 1024) {
        e.preventDefault();
        const drawer = document.querySelector(`.flyout-drawer[data-index="${index}"]`);
        if (drawer.classList.contains("open")) {
          closeAllDrawers();
        } else {
          openDrawer(index);
        }
      }
    });
  });

  // Close buttons
  document.querySelectorAll(".flyout-drawer__close").forEach(btn => {
    btn.addEventListener("click", () => {
      closeAllDrawers();
    });
  });

  // Submenu open
  document.querySelectorAll(".flyout-drawer__link.has-submenu").forEach(link => {
    link.addEventListener("click", e => {
      e.preventDefault();
      const target = link.dataset.submenu;
      const submenu = document.querySelector(`.flyout-submenu[data-submenu="${target}"]`);
      if (submenu) {
        submenu.classList.add("open");
        submenu.setAttribute("aria-hidden", "false");
      }
    });
  });

  // Submenu back
  document.querySelectorAll(".flyout-submenu__back").forEach(btn => {
    btn.addEventListener("click", () => {
      const submenu = btn.closest(".flyout-submenu");
      submenu.classList.remove("open");
      submenu.setAttribute("aria-hidden", "true");
    });
  });

  // Close all drawers when mouse leaves on desktop
  drawers.forEach(drawer => {
    drawer.addEventListener("mouseleave", () => {
      if (window.innerWidth > 1024) {
        closeAllDrawers();
      }
    });
  });
});
